<template>
  <div class="pm-dialog-order-type">
    <div class="flex justify-center dialog-content" style="padding:1rem;">
      <div @mousedown="selectedId = master.id" class="vs-col" v-for="(master,index) in masterList" :key="index" style="margin:0.2rem;min-width: 5rem;">
        <vs-chip
          style="min-width:5rem;"
          :color="(String(selectedId) === String(master.id)) ?
            String(selectedId) === '1' ? '#5286ED' :  
            String(selectedId) === '2' ? '#A8309C' : 
            String(selectedId) === '3' ? '#34A118' : 
            String(selectedId) === '5' ? '#A8309C' : 
            String(selectedId) === '6' ? '#5286ED' : 
            '#4F4F4F' : '#bdbdbd'"
          class="pm-input-key"
        >
          {{ master.value }}
        </vs-chip>
      </div>
    </div>
    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
// Editでは修正
// const { mapActions, mapState, mapGetters } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  data() {
    return {
      selectedId: null,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      const sortOrderList = this.masterMap['order_type_sorts'].map(x => x.value);
      let masterList = [];
      for(let sortOrder of sortOrderList ) {
        const orderType = this.masterMap['order_type'].find(x => x.id == sortOrder);
        if ( orderType ) {
          masterList.push(orderType);
        }
      }
      return masterList;
    },
    enableSave() {
      return true; // ( this.selectedId );
    },
  },
  methods: {
    initData() {
      this.selectedId = this.valueMap ? this.valueMap.id : null;
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.enableSave) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.enableSave) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = String(this.selectedId);
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";

.pm-dialog-order-type {
  .dialog-content {
    flex-wrap: wrap;
  }
  .con-vs-chip {
    border-radius:5px;
    height:2.2rem;
    font-size: 120%;
  }
  .pm-input-key {
    background-color: $pm-paper-white;
    border: 1px solid $pm-gray;
    color: $pm-black;
    cursor: pointer;
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
}
</style>

